import { CFormLabel, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import Select from 'react-select'
import { Plus } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import CustomDatePickingFormat from './CustomDatePickingFormat'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const questionFields = [
  { key: 'rollLeftAndRight', label: 'Roll left and right' },
  { key: 'sitToLying', label: 'Sit to lying' },
  { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
  { key: 'sitToStand', label: 'Sit to stand' },
  { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
  { key: 'toiletTransfer', label: 'Toilet transfer' },
  { key: 'walk10Feet', label: 'Walk 10 feet' },
  { key: 'ambulatoryAids', label: 'Ambulatory aids' },
]

const commonOptions = [
  { label: 'Independent', value: 'independent' },
  { label: 'Set up or cleanup assistance', value: 'setup_or_cleanup_assistance' },
  { label: 'Supervision or touching assistant', value: 'supervision_or_touching_assistant' },
  { label: 'Partial moderate assistant', value: 'partial_moderate_assistant' },
  { label: 'Substantial maximal assistant', value: 'substantial_maximal_assistant' },
  { label: 'Dependent', value: 'dependent' },
  { label: 'Patient refused', value: 'patient_refused' },
]

const ambulatoryOptions = [
  { label: 'None', value: 'none' },
  { label: 'Wheelchair', value: 'wheelchair' },
  { label: 'Cane', value: 'cane' },
  { label: 'Walker', value: 'walker' },
]

const MobilityAssessment = ({ noteStructureRef, diagnosisName,saveTreatsShell, showDataIfNoteIsFollowUp = true, setNoteRefTrigger, showTreatmentAsAccordion = false }) => {
  const [visible, setVisible] = useState(false)
  const [date, setDate] = useState('')
  const [selectedData, setSelectedData] = useState({
    rollLeftAndRight: [],
    sitToLying: [],
    lyingToSittingOnSideOfBed: [],
    sitToStand: [],
    chairToBedTransfer: [],
    toiletTransfer: [],
    walk10Feet: [],
    ambulatoryAids: [],
  })
    const [showEditHtml, setShowEditHtml] = useState(false);
    const [tempHtmlContent, setTempHtmlContent] = useState('');

  const [modalState, setModalState] = useState({
    data: {
      rollLeftAndRight: [],
      sitToLying: [],
      lyingToSittingOnSideOfBed: [],
      sitToStand: [],
      chairToBedTransfer: [],
      toiletTransfer: [],
      walk10Feet: [],
      ambulatoryAids: [],
    },
    date: '',
  })

  const mobilitySelectProps = {
    className: 'ui-react-select basic-multi-select',
    classNamePrefix: 'select',
    menuPlacement: 'auto',
    menuShouldScrollIntoView: false,
    maxMenuHeight: 220,
  }

  useEffect(() => {
    if (noteStructureRef.current?.MobilityAssessment) {
      const existingData = noteStructureRef.current.MobilityAssessment
      setSelectedData(
        existingData.assessment || {
          rollLeftAndRight: [],
          sitToLying: [],
          lyingToSittingOnSideOfBed: [],
          sitToStand: [],
          chairToBedTransfer: [],
          toiletTransfer: [],
          walk10Feet: [],
          ambulatoryAids: [],
        },
      )
      setDate(existingData.date || '')

      setModalState({
        data: existingData.assessment || {
          rollLeftAndRight: [],
          sitToLying: [],
          lyingToSittingOnSideOfBed: [],
          sitToStand: [],
          chairToBedTransfer: [],
          toiletTransfer: [],
          walk10Feet: [],
          ambulatoryAids: [],
        },
        date: existingData.date || '',
      })
    }
  }, [visible, noteStructureRef])

  const handleModalChange = (selectedOptions, key) => {
    setModalState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [key]: selectedOptions || [],
      },
    }))
  }

  const handleModalDateChange = (newDate) => {
    setModalState((prev) => ({
      ...prev,
      date: newDate,
    }))
  }

  const updateNoteStructure = (data, updatedDate) => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      MobilityAssessment: {
        date: updatedDate || '',
        assessment: data || {},
      },
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          MobilityAssessment: {
            date: updatedDate || '',
            assessment: data || {},
          },
        },
      },
    }
    setNoteRefTrigger((prev) => prev + 1)
  }

  const handleSaveData = () => {
    updateNoteStructure(modalState.data, modalState.date)
    setSelectedData(modalState.data)
    setDate(modalState.date)
    setVisible(false)
  }

  const onClear = () => {
    const cleared = {
      rollLeftAndRight: [],
      sitToLying: [],
      lyingToSittingOnSideOfBed: [],
      sitToStand: [],
      chairToBedTransfer: [],
      toiletTransfer: [],
      walk10Feet: [],
      ambulatoryAids: [],
    }
    setSelectedData(cleared)
    setDate('')
    setVisible(false)
  }

  return (
    <div>
      <div className="d-flex align-items-center gap-2 ">
        <b>Mobility Assessment:MDS - GG</b>
        {!showTreatmentAsAccordion && (
          <CFormLabel
            className="patient-note-action d-flex flex-column align-items-center justify-content-center shadow mt-2"
            onClick={() => setVisible((p) => !p)}
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '20px',
              background: 'var(--ui-color-primary, #2b7cd3)',
              cursor: 'pointer',
            }}
          >
            <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
          </CFormLabel>
        )}
      </div>
     <hr />
      {noteStructureRef?.current?.freeTypesEverything?.MobilityAssessment?.[diagnosisName] && (
        <div className="my-2">
          <div
            className="p-2 patient-theme-old-data patient-theme-old-data--readonly patient-theme-old-data--final-note"
            dangerouslySetInnerHTML={{
              __html:
                noteStructureRef?.current?.freeTypesEverything?.MobilityAssessment?.[diagnosisName],
            }}
          ></div>
        </div>
      )}
      
      <div className={` ${showTreatmentAsAccordion ? ' px-3' : 'border rounded p-3 bg-light bg-secondary'}`} style={{ fontSize: '14px', color: 'var(--ui-text-primary)' }}>
        {date && (
          <div className="mb-2">
            <strong>Date :</strong> {date}
          </div>
        )}
        {questionFields.map((field) => {
          const selected = selectedData[field.key]
          if (selected && selected.length > 0) {
            const values = selected.map((item) => item.label).join(', ')
            return (
              <div key={field.key} className="mb-2">
                <strong>{field.label}:</strong> {values}
              </div>
            )
          }
          return null
        })}
      </div>

      <CModal className="patient-theme-modal patient-note-form-modal assessment-theme__modal" backdrop="static" size="lg" visible={visible}>
        <CModalHeader>
          <CModalTitle>Mobility Assessment:MDS - GG</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="px-4 py-3">
            <div className="container" style={{ height: '500px', overflowY: 'auto' }}>
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3 " style={{ width: '40%' }}>
                  <CFormLabel className="fw-medium mb-0">Date:</CFormLabel>
                  <CustomDatePickingFormat value={modalState.date} onChange={handleModalDateChange} />
                </div>
              </div>
              {questionFields.map((field) => (
                <div className="row mb-3" key={field.key}>
                  <CFormLabel className="fw-medium mb-1">{field.label}</CFormLabel>
                  <Select {...mobilitySelectProps} isMulti options={field.label === 'Ambulatory aids' ? ambulatoryOptions : commonOptions} value={modalState.data[field.key]} onChange={(selected) => handleModalChange(selected, field.key)} />
                </div>
              ))}
            </div>
          </div>
        </CModalBody>
        <CModalFooter style={{ borderTop: '1px solid #f1f1f1' }} className="m-0 p-0 py-2 pb-4 px-4">
          <CButton variant="outline" color="secondary" onClick={onClear}>
            Close
          </CButton>
          <CButton disabled={!modalState.date || Object.values(modalState.data).every((arr) => arr.length === 0)} color="primary" onClick={handleSaveData}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>


                  <CModal
                    className="patient-theme-modal patient-note-form-modal assessment-theme__modal"
                    size="lg"
                    visible={showEditHtml}
                    onClose={() => setShowEditHtml(false)}
                    aria-labelledby="OptionalSizesExample2"
                  >
                    <CModalHeader>
                      <CModalTitle id="OptionalSizesExample2">
                        Edit Morse Score Free Type
                      </CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                      <Editor
                        onChange={(e) => {
                          setTempHtmlContent(e.target.value);
                        }}
                        containerProps={{
                          style: {
                            width: '100%',
                            background: 'var(--ui-bg-inset, #161616)',
                            border: 0,
                            height: "100%",
                            minHeight: "unset"
                          },
                        }}
                        value={tempHtmlContent}
                      >
                        <tooltip />
                      </Editor>
                    </CModalBody>
                     <CModalFooter>
                      <CButton
                        variant="outline"
                        color="secondary"
                        onClick={() => setShowEditHtml(false)}
                      >
                        Close
                      </CButton>
                      <CButton
                        color="primary"
                        onClick={() => {
                          noteStructureRef.current = {
                            ...noteStructureRef.current,
                            freeTypesEverything: {
                              ...noteStructureRef.current?.freeTypesEverything,
                              MobilityAssessment: {
                                ...noteStructureRef.current?.freeTypesEverything?.MobilityAssessment,
                                [diagnosisName]: tempHtmlContent,
                              }
                            },
                          };
                          saveTreatsShell(false);
                          setShowEditHtml(false)
                        }}
                      >
                        Save Changes
                      </CButton>
                    </CModalFooter>
                  </CModal>
    </div>
  )
}

export default MobilityAssessment
